// Where each participant of a group stands (29.10.2026): the words and the
// filters of the "Etapa" column. The steps themselves come from the API.

export const WAITS = [
  { key: "team", label: "Așteaptă echipa", tone: "bg-[#E63946]/10 text-[#b42a35]" },
  { key: "participant", label: "Așteaptă participantul", tone: "bg-[#FDE68A]/70 text-[#8a6a1a]" },
  { key: "platform", label: "Automat", tone: "bg-[#3F8EBA]/12 text-[#1f5d80]" },
  { key: "ready", label: "Gata", tone: "bg-[#519872]/15 text-[#3c7457]" },
];

export const waitsOf = (key) => WAITS.find((w) => w.key === key) || WAITS[0];

// "13 plătite · 11 cu date · …": what a done step means, counted.
const DONE_WORDS = {
  payment: "plătite sau confirmate",
  dossier: "cu date completate",
  contract: "cu contract semnat",
  portal: "au intrat în portal",
  logiscool: "cu acces Logiscool",
};

export function doneLine(journey) {
  if (!journey || !journey.total) return "";
  const parts = (journey.steps || []).map((k) => `${journey.done?.[k] ?? 0} ${DONE_WORDS[k] || k}`);
  return [`${journey.total} ${journey.total === 1 ? "participant" : "participanți"}`, ...parts].join(" · ");
}

export const STEP_TONE = {
  done: "bg-[#519872] text-white",
  doing: "bg-[#d99a2b] text-white",
  blocked: "bg-[#E63946] text-white",
  later: "bg-[#E5E7EB] text-[#6B7280]",
};

export function matchesWaits(journey, enrollmentId, filter) {
  if (!filter) return true;
  return journey?.rows?.[enrollmentId]?.summary?.waits === filter;
}
